import React from "react";
import { useTheme } from "react-jss";
import useStyles from "./ButtonGroup.styles";
import { FontAwesomeIcon } from "./FontAwesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import classNames from "classnames";

interface GroupButtonInheritedProps {
    size?: "small" | "large";
    isGrid?: boolean;
}

interface GroupButtonProps {
    text?: React.ReactNode;
    icon?: IconProp;
    inheritedProps?: GroupButtonInheritedProps;
    onClick?(): void;
    active?: boolean;
    disabled?: boolean;
}

function GroupButton(props: GroupButtonProps) {
    const { text, icon, active, disabled, onClick, inheritedProps } = props;
    const { size = "large", isGrid } = inheritedProps;

    const theme = useTheme();
    const classes = useStyles({ theme, size });

    let content = text;
    if (icon) content = <FontAwesomeIcon icon={icon} />;

    return (
        <div
            onClick={!disabled ? onClick : undefined}
            className={classNames(
                classes.groupButton,
                isGrid ? classes.groupButtonGrid : classes.groupButtonNoGrid,
                disabled && classes.groupButtonDisabled,
                active && classes.groupButtonActive,
            )}
            role="button"
        >
            {content}
        </div>
    );
}

interface Props {
    children: any;
}

export default function ButtonGroup(props: Props & GroupButtonInheritedProps) {
    const { children, size } = props;

    const theme = useTheme();
    const classes = useStyles({ theme, size });

    const clonedChildren = React.Children.map(children, (child) => {
        return child && React.cloneElement(child, { inheritedProps: props });
    });

    return <div className={classes.buttonGroup}>{clonedChildren}</div>;
}

ButtonGroup.Button = GroupButton;
